var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChangeLocationIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 6.30176C1.66699 4.77682 1.66699 4.01435 1.93773 3.42105C2.23759 2.76396 2.76444 2.2371 3.42154 1.93725C4.01484 1.6665 4.77731 1.6665 6.30225 1.6665H6.93092C7.29973 1.6665 7.48414 1.6665 7.65427 1.68599C8.54197 1.78767 9.33814 2.27973 9.82607 3.02823C9.91959 3.17169 10.0021 3.33663 10.167 3.6665V3.6665C10.2769 3.88642 10.3319 3.99638 10.3943 4.09202C10.7196 4.59102 11.2503 4.91906 11.8421 4.98685C11.9556 4.99984 12.0785 4.99984 12.3244 4.99984H12.6042C14.2143 4.99984 15.0194 4.99984 15.666 5.22826C16.8059 5.63095 17.7025 6.52757 18.1052 7.66746C18.3337 8.31406 18.3337 9.11915 18.3337 10.7293V11.9332C18.3337 14.1734 18.3337 15.2935 17.8977 16.1491C17.5142 16.9018 16.9023 17.5137 16.1496 17.8972C15.294 18.3332 14.1739 18.3332 11.9337 18.3332H8.06699C5.82678 18.3332 4.70668 18.3332 3.85103 17.8972C3.09838 17.5137 2.48646 16.9018 2.10297 16.1491C1.66699 15.2935 1.66699 14.1734 1.66699 11.9332V6.30176Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 14L13 11.5M13 11.5L10.6667 9M13 11.5L10 11.5L7 11.5",
    stroke: "#22272F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChangeLocationIcon);
export default ForwardRef;